<template>
    <div :id="localChartId"></div>
</template>

<script>
import echartsMixin from "@/components/echarts-part/kpi/stuff/mixin/echartsMixin";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "CommonChart",
    mixins: [echartsMixin, emCommonUtilMixin],
    props: {
        chartId: String,
        options: Object
    },
    computed: {
        localChartId() {
            if (this.chartId) {
                return this.chartId;
            } else {
                return this.genNonDuplicateID(4);
            }
        },
    }
}
</script>

<style scoped>

</style>